import React from 'react';
import { Box } from '@mui/material';
import { translations } from '../../lib';

const DataProcessingContent = (): any => {
    return (
        <Box sx={{ width: '100%', height: 400, paddingTop: '15px', overflowY: 'scroll' }}>
            <p>{translations.intro.DATA_PROCESSING_TITLE}</p>
            <p>{translations.intro.DATA_PROCESSING_CONTENT}</p>
            <ul>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_LIST_1}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_LIST_2}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_LIST_3}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_LIST_4}</li>
            </ul>
            <p style={{ textDecoration: 'underline' }}>{translations.intro.DATA_PROCESSING_SUBTITLE_1}</p>
            <ol>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_1_1}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_1_2}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_1_3}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_1_4}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_1_5}</li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_1_6}</li>
            </ol>
            <p style={{ textDecoration: 'underline' }}>{translations.intro.DATA_PROCESSING_SUBTITLE_2}</p>
            <p>{translations.intro.DATA_PROCESSING_CONTENT_2_1}</p>
            <p>{translations.intro.DATA_PROCESSING_CONTENT_2_2}</p>
            <p style={{ textDecoration: 'underline' }}>{translations.intro.DATA_PROCESSING_SUBTITLE_3}</p>
            <p>{translations.intro.DATA_PROCESSING_CONTENT_3}</p>
            <p style={{ textDecoration: 'underline' }}>{translations.intro.DATA_PROCESSING_SUBTITLE_4}</p>
            <p>{translations.intro.DATA_PROCESSING_CONTENT_4_1}</p>
            <p>{translations.intro.DATA_PROCESSING_CONTENT_4_2}</p>
            <p style={{ textDecoration: 'underline' }}>{translations.intro.DATA_PROCESSING_SUBTITLE_5}</p>
            <p>{translations.intro.DATA_PROCESSING_CONTENT_5}</p>
            <ul>
                <li>
                    {translations.intro.DATA_PROCESSING_CONTENT_5_CALL_CENTER}
                    <a
                        style={{ color: '#c21b17' }}
                        href={translations.intro.DATA_PROCESSING_CONTENT_5_CALL_CENTER_NUMBER_HREF}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {translations.intro.DATA_PROCESSING_CONTENT_5_CALL_CENTER_NUMBER}
                    </a>
                </li>
                <li>
                    {translations.intro.DATA_PROCESSING_CONTENT_5_EMAIL}
                    <a
                        style={{ color: '#c21b17' }}
                        href={`mailto:${translations.intro.DATA_PROCESSING_CONTENT_5_EMAIL_ADDRESS}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {translations.intro.DATA_PROCESSING_CONTENT_5_EMAIL_ADDRESS}
                    </a>
                </li>
                <li>{translations.intro.DATA_PROCESSING_CONTENT_5_MAIL}</li>
            </ul>
        </Box>
    );
};

export default DataProcessingContent;
